import STATUS from '../../../globalStatuses';

export const ACTIONS = {
  REQUEST: 'REQUEST_FINANCIAL_SAVINGS_PREPARATION',
  METADATA: 'RECEIVE_FINANCIAL_SAVINGS_METADATA',
  RECEIVE: 'RECEIVE_FINANCIAL_SAVINGS_PREPARATION',
  ERROR: 'ERROR_FINANCIAL_SAVINGS_PREPARATION',
};
export const initialState = {
  status: STATUS.UNFETCHED, key: null, requestId: null, metadata: null,
};

// eslint-disable-next-line default-param-last
export default function financialSavings(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.REQUEST:
      return {
        ...state,
        status: STATUS.FETCHING,
        key: action.key,
        requestId: action.requestId,
        error: null,
      };
    case ACTIONS.METADATA:
      if (state.requestId !== action.requestId) return state;
      return { ...state, metadata: action.metadata, metadataUserKey: action.userKey };
    case ACTIONS.RECEIVE:
      if (state.requestId !== action.requestId) return state;
      return {
        ...state, ...action.receipt, status: STATUS.FETCHED, error: null,
      };
    case ACTIONS.ERROR:
      if (state.requestId !== action.requestId) return state;
      return {
        ...state, key: action.key, status: STATUS.ERROR, error: action.error,
      };
    default:
      return state;
  }
}
